export const plotMap = {
  LINE: 'line',
  BAR: 'bar',
};